import apiClient from 'ps-components/lib/apiClient';
import { IGetOrgJobsAPIParams, IGetMatchDataAPIParams, IGetDataCutsParams, ITerm, IAddMatchesParams, IRemoveMatchData, IUpdateMatchesParams } from './Types/BulkPricingTypes';
import { CATEGORY_CODE, PAGE_CODE } from '../../../lib/pageCodeDefaults';
import addAlert from 'ps-components/AlertToast/addAlert';

export const getOrgJobsData = async ({ jobs, masterAccountID }: IGetOrgJobsAPIParams) => {
  const orgJobsURL = `/cms/api/accounts/${masterAccountID}/org-jobs`;

  const options = {
    data: {
      category_code: CATEGORY_CODE.BULK_PRICING_ORG_JOBS,
      page_code: PAGE_CODE.BULK_PRICING_ORG_JOBS,
      idList: [] as { id: number; score: number }[],
    }
  };
  jobs.forEach((job) => options.data.idList.push({id: job.jobID as number, score: 1}));
  try {
    const results = await apiClient.post(orgJobsURL, options);
    const orgJobsData = results.data.data;
    return orgJobsData;
  } catch (error) {
    console.error(`Error fetching org job data:`, error);
    addAlert('Error fetching org job data.', 'danger');

    return Promise.resolve({ data: [], terms: [] });

  }
};

export const getMatchData = async ({ masterAccountID, benchmarkYear, currency, jobCode, jobCodeKey, displayIn }: IGetMatchDataAPIParams) => {
  const matchesURL = `/cms/api/accounts/${masterAccountID}/org-jobs/pricing`;

  try {
    const options = {
      benchmarkYear,
      currency,
      displayIn,
      jobCode,
      jobCodeKey,
      pageCode: 'bulk_pricing_price'
    };

    const results = await apiClient.post(matchesURL, options);
    const matchesData: (string | number | null)[][] = results.data.data.data;
    const matchesTerms: ITerm[] = results.data.data.terms;

    return { data: matchesData, terms: matchesTerms};
  } catch (error) {
    console.error('Error fetching match data:', error);
    addAlert('Error fetching match data.', 'danger');

    return []
  }
};

export const deleteBulkMatches = async (removeMatchesData: IRemoveMatchData[]) => {
  const successMessage = `Successfully removed survey match/data cut(s)`;
  const errorMessage = `Error removing survey match/data cut(s): `;

  try {
    const result = await apiClient.apiDelete('api/market-pricing/job-matches-many/removeMatches', {
      data: {
        removeMatchesData,
      },
    });

    if (result.data.success) {
      console.log(successMessage);
      addAlert(successMessage, 'success');
      return { success: true };
    } else {
      console.error(errorMessage, result.data.reason);
      addAlert(`${errorMessage}${result.data.reason}`, 'danger');
      return { success: false, reason: result.data.reason };
    }
  } catch (error) {
    console.error(errorMessage, error);
    addAlert(`${errorMessage}${error}`, 'danger');
    return { success: false, error };
  }
};

export const getDataCuts = async ({ masterAccountID, benchmarkYear, displayIn, currency, newCuts }: IGetDataCutsParams) => {
  const matchesURL = `/cms/api/accounts/${masterAccountID}/survey-jobs`;
  try {
    const options = {
      benchmarkYears: [benchmarkYear],
      data: newCuts,
      currency,
      displayIn,
      limitSubscribedSurveys: true,
      pageCode: "bulk_pricing_survey_search",
      returnResults: true
    };
    const results = await apiClient.post(matchesURL, options);
    return results.data;
  } catch (error) {

    console.error('Error fetching data cuts:', error);
    addAlert('Error fetching data cuts.', 'danger');
  }
};

export const addMatches = async ({ orgJobID, cutIDs, benchmarkYear, agingCode }: IAddMatchesParams) => {
  try {
    const results = await apiClient.apiPost('/api/market-pricing/job-matches-many/addMatches', {
      org_job_id: orgJobID,
      cut_ids: cutIDs,
      benchmarkYear,
      aging_code: agingCode,
    });
    return { data: results.data };
  } catch (error) {
    console.error('Error adding matches:', error);
    addAlert('Error adding matches', 'danger');
    return { data: error.response.data };
  }
};

export const updateMatches = async ({ orgJobId, matches, benchmarkYear, editPastYears }: IUpdateMatchesParams) => {
  try {
    /** first update the match */
    await apiClient.apiPut('/api/market-pricing/job-matches/updateMatches', {
      org_job_id: orgJobId,
      matches,
      metaData: {},
      benchmarkYear,
      editPastYears
    });

    /** then update the match summaries */
    await apiClient.apiPut('/api/market-pricing/jobs/updateMeritMatchSummaries', {
      orgJobId,
      benchmarkAdjustment: undefined,
      benchmarkComment: undefined,
      benchmarkYear,
      editPastYears
    });
  } catch (error) {
    console.error('Error updating matches:', error);
    addAlert('Error updating matches', 'danger');
  }
};